import axios from "../axios/axios";

const fetchData = async () => {
  try {
    const response = await axios.get("/stripe-tvi-plan");
    if (response.data.status) {
      return response.data;
    } else {
      console.error("Error: Data status is false");
      return null;
    }
  } catch (error) {
    console.error("Error fetching data:", error);
    return null;
  }
};

let data = null;
if (localStorage.getItem("products_stripe") === null) {
  data = await fetchData();
  localStorage.setItem("products_stripe", JSON.stringify(data));
} else {
  data = JSON.parse(localStorage.getItem("products_stripe"));
}


export const products = data.data;

